export default {
  title: 'Impressum',
  subtitle: 'Personnalisez les informations affichées dans votre Impressum sans modifier votre profil commercial.',
  defaultsNotice:
    "Chaque champ est optionnel. Laissez-en un vide pour conserver la valeur de votre profil commercial — la valeur par défaut actuelle est affichée en gris en aperçu. Remplir un champ remplace uniquement l'Impressum ; votre profil commercial reste inchangé.",
  fields: {
    legal_name: {
      label: 'Raison sociale / nom légal',
      placeholder: 'ex. : Musterbetrieb GmbH',
    },
    owner_first_name: {
      label: 'Prénom du propriétaire',
      placeholder: 'ex. : Alex',
    },
    owner_last_name: {
      label: 'Nom du propriétaire',
      placeholder: 'ex. : Müller',
    },
    owner_email: {
      label: 'E-mail',
      placeholder: 'ex. : info@example.com',
      invalid: 'Veuillez saisir une adresse e-mail valide',
    },
    owner_phone_number: {
      label: 'Téléphone',
      placeholder: 'ex. : +49 30 1234567',
    },
    tax_id: {
      label: 'Numéro fiscal',
      placeholder: 'ex. : DE123456789',
    },
    address: {
      label: 'Adresse',
      placeholder: 'Rue, code postal, ville',
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    saved: 'Impressum enregistré',
    failed: "Échec de l'enregistrement de l'Impressum",
  },
};
